import React from 'react';
import { useHistory } from 'react-router-dom';
import { StepRecord } from 'types/dynamic-forms/records/StepRecord';
import DynamicContentRenderer from '../DynamicContentRenderer';
import useDocumentNav from '../hooks/useDocumentNav';
import { TabViewStyled } from 'styles/v2/Styles.styled';
import { TabPanel } from 'primereact/tabview';

const StepRenderer: React.FC<StepRecord> = ({ children }) => {
  const history = useHistory();
  const { tab, step, getUrl } = useDocumentNav();

  const tabs = children.filter((c) => c.__typename === 'tab');
  if (tabs.length === 0) {
    return <DynamicContentRenderer schema={children} />;
  }

  let tabIndex = tabs.findIndex((t) => t.query === tab);
  if (tabIndex === -1) {
    tabIndex = 0;
  }

  return (
    <TabViewStyled activeIndex={tabIndex} onTabChange={(e) => history.push(getUrl(step, tabs[e.index].query))}>
      {tabs.map((t) => (
        <TabPanel key={t.tabName} header={t.tabName}>
          <DynamicContentRenderer schema={t.children} />
        </TabPanel>
      ))}
    </TabViewStyled>
  );
};

export default StepRenderer;
